import React from "react";

function PageBreak() {
    return(
        <div>
            <hr className="line-top" />
            <hr className="line-bottom" />
        </div>
    );
}

export default PageBreak;